import React from 'react';
import Markdown from '../../../components/markdown';
import { useFetchDocuments } from '../../../hooks/documents/use-fetch-documents';

const Policy: React.FC = () => {
  const { content } = useFetchDocuments('privacy');

  return <Markdown content={content} />;
};

export default Policy;
